import React from 'react'
import { Field, Form } from 'react-final-form'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { decodeJWT } from '../../../../../shared/decodeJWT'
import normalizePhone from '../../../../../shared/normalizers/normalizePhone'
import { validate } from './HaulerTeamMemberEditFormUtils'
import { TextInput } from '../../../../../../components/TextInput'
import { SelectInput } from '../../../../../../components/SelectInput'
import { RadioInput } from '../../../../../../components/RadioInput'
import styles from './index.module.scss'

export default function HaulerTeamMemberEditForm ({ onSubmit, initialValues, isLoading }) {
  return (
    <div className='dis-panel dis-panel-body'>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}>
        {({
          handleSubmit,
          pristine,
          submitting
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={cn(styles.formWrapper)}>
              <div className={cn(styles.panel)}>
                <Field
                  name='firstName'
                  label='First Name'
                  component={TextInput}
                  maxLength='99'>
                  {({ input, meta }) => (
                    <div className={cn({ 'has-error': (meta.error && meta.touched) })}>
                      <label className='control-label' htmlFor='firstName'>First Name</label>
                      <input
                        {...input}
                        type='text'
                        className={cn('form-control')}
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                </Field>
                <Field
                  name='lastName'
                  label='Last Name'
                  component={TextInput}
                  maxLength='99'>
                  {({ input, meta }) => (
                    <div className={cn({ 'has-error': (meta.error && meta.touched) })}>
                      <label className='control-label' htmlFor='lastName'>Last Name</label>
                      <input
                        {...input}
                        type='text'
                        className={cn('form-control')}
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                </Field>
                {decodeJWT().u !== Number(initialValues.id) && (
                  <div>
                    <Field
                      name='role'
                      component={SelectInput}
                      label='Role'
                      options={{ hauler_admin: 'Company Admin', hauler_driver: 'Company Driver' }}
                    />
                  </div>
                )}
              </div>
              <div className={cn(styles.panel)}>
                <Field
                  name='email'
                  type='email'
                  label='Email'
                  component={TextInput}
                  maxLength='64'>
                  {({ input, meta }) => (
                    <div className={cn({ 'has-error': (meta.error && meta.touched) })}>
                      <label className='control-label' htmlFor='email'>Email</label>
                      <input
                        {...input}
                        type='text'
                        className={cn('form-control')}
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                </Field>
                <Field
                  name='prettyPrimaryPhone'
                  label='Primary Phone Number'
                  component={TextInput}
                  normalize={normalizePhone}>
                  {({ input, meta }) => (
                    <div className={cn({ 'has-error': (meta.error && meta.touched) })}>
                      <label className='control-label' htmlFor='prettyPrimaryPhone'>Primary Phone Number</label>
                      <input
                        {...input}
                        type='text'
                        className={cn('form-control')}
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                </Field>
                <div className='w-full'> Show User Icon on Dispatch Map?</div>
                <Field
                  classNames='mr-8'
                  name='trackLocation'
                  radioVal={true}
                  label='Yes'
                  component={RadioInput}
                />
                <Field
                  name='trackLocation'
                  radioVal={false}
                  label='No'
                  component={RadioInput}
                />
              </div>
            </div>
            <div className={cn(styles.submitContainer)}>
              <button type='submit'
                className={cn('dis-btn dis-btn-lg dis-btn-primary')}
                disabled={pristine || submitting || isLoading}>
                Save Changes
                <i className='material-icons dis-btn-icon'>check</i>
              </button>
            </div>
          </form>
        )}
      </Form>
    </div>
  )
}

HaulerTeamMemberEditForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  isLoading: PropTypes.bool
}
